<template>
    <div class="row">
        <div class="col-auto">
            <div class="card">
                <div class="card-body">
                    <div class="card-text row">
                        
                        <!-- 請求年月 -->
                        <input-date
                            style="width: 150px;"
                            v-model="createForm.DRAW_YM"
                            :error="createErrors.DRAW_YM"
                            :label-attr="{ for: 'DRAW_YM', title: dg.SalTDraw.DRAW_YM }"
                            :input-attr="{ type: 'month' }"
                        ></input-date>

                        <div class="col-auto d-flex gap-1 align-items-start" style="margin-top: 23px">
                            <a href="#" class="btn btn-primary btn-sm" @click.prevent.stop="create()">{{ dg.draw.create }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-auto">
            <form ref="form" @submit.prevent="getDraws()" class="mb-2">
                <div class="card">
                    <div class="card-body">
                        <div class="card-text row">

                            <!-- 開始日 -->
                            <input-date
                                style="width: 160px;"
                                v-model="form.START_DAY"
                                :error="errors.START_DAY"
                                :label-attr="{ for: 'START_DAY', title: dg.START_DAY }"
                            ></input-date>
                            
                            <!-- 終了日 -->
                            <input-date
                                style="width: 160px;"
                                v-model="form.END_DAY"
                                :error="errors.END_DAY"
                                :label-attr="{ for: 'END_DAY', title: dg.END_DAY }"
                            ></input-date>

                            <!-- 状態 -->
                            <div class="col-auto" style="z-index: 1029; width: 170px;">
                                <label for="STATUS" class="form-label">{{ dg.SalTSales.STATUS }}</label>
                                <VueMultiselect
                                    v-model="form.STATUS"
                                    :custom-label="setStatusLabel"
                                    :options="statusListArray"
                                    label="name"
                                    :close-on-select="false"
                                    :taggable="false"
                                    :multiple="true"
                                    :searchable="false"
                                    placeholder="未選択"
                                    selectLabel="選択"
                                    selectedLabel="選択済"
                                    deselectLabel="解除"
                                    :limitText="count => `+${count}`"
                                    :limit="1"
                                >
                                </VueMultiselect>
                                <error-message :error="errors.STATUS"></error-message>
                            </div>
                            <div class="col-auto d-flex gap-1 align-items-start" style="margin-top: 23px">
                                <button type="button" class="btn btn-secondary btn-sm" @click="reset()">リセット</button>
                                <button type="submit" class="btn btn-primary btn-sm">検索</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <draw-index-table ref="table"
        v-model="draws"
        :document-root="documentRoot"
        :dg="dg"
        :invoice-status-list="invoiceStatusList"
        :session-name="sessionName"
        :sort="sort"
    ></draw-index-table>
</template>

<script>
import moment from "moment";
import Mixin from '../mixins/mixin'
import DrawIndexTable from './DrawIndexTable.vue';
import InputDate from '../inputs/InputDate.vue';
import VueMultiselect from 'vue-multiselect';

export default {
    name: 'DrawIndex',
    mixins: [Mixin],
    components: {
        DrawIndexTable,
        InputDate,
        VueMultiselect,
    },
    props: {
        dg: Object,
        documentRoot: String,
        invoiceStatusList: Object,
    },
    data() {
        return {
            form        : {},
            draws       : [],
            errors      : {},
            createErrors: {},
            createForm  : { DRAW_YM: moment().format("YYYY-MM") },
            sort        : {},
            sessionName : 'drawIndex',
        }
    },
    async created() {
        // プロパティ初期化
        this.init();
        // セッションの操作
        this.sessionHandler();
        // 一覧の取得
        await this.getDraws();
        // 指定値までスクロール
        this.$refs.table.scroll(this.scroll);
    },
    methods: {
        sessionHandler() {
            const sessionData = this.getSession(this.sessionName);
            const sessionDataKeys = ['form', 'scroll', 'sort', 'createForm'];
            
            // セッションのデータキーを順に確認し、
            sessionDataKeys.forEach(key => {
                // キーが存在する場合、セッションから代入
                if (key in sessionData) {
                    this[key] = sessionData[key]
                // キーが存在しない場合、セッションに値を保存
                } else {
                    this.setSession(this.sessionName, { [key]: this[key] })
                }
            });
        },
        init() {
            // 検索条件
            this.form = {
                START_DAY   : moment().subtract(3, 'M').subtract(1, 'y').format('YYYY-04-01'),
                END_DAY     : moment().subtract(3, 'M').add(1, 'y').format('YYYY-03-31'),
                STATUS      : '',
            }
            // スクロール量
            this.scroll = 0;
            // ソート
            this.sort = {
                key: 'DRAW_YM',
                asc: false,
            }
        },
        handleTableScroll(e) {
            this.setSession(this.sessionName, { scroll: e.target.scrollTop } );
        },
        getDraws() {
            this.errors = {};
            return axios.get(`/draw/search`, { params: this.form })
                .then(res => {
                    this.draws = res.data.data;
                    // 検索条件をセッション保存
                    this.setSession(this.sessionName, { form : this.form });
                })
                .then(() => this.$refs.table.init())
                .catch((error) => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    } else if (error.response.status === 500) {
                        const status = error.response.status;
                        window.alert(this.dg.internal_error);
                    }
                });
        },
        async create() {
            this.createErrors = {};

            const regex = /^[0-9]{4}\-(0[1-9]|1[0-2])$/;
            if (!regex.test(this.createForm.DRAW_YM)) {
                this.createErrors = { DRAW_YM : [this.dg.pleaseInputCorrectYearMonth] };
                return;
            }

            try {
                const result = await axios.get(`/draw/check`, { params: this.createForm });
                if(result.data) {
                    alert('引落情報は作成済みです')
                    return;
                };
                const isSalesExist = await axios.get(`/draw/is_sales_exist`, { params: this.createForm });
                if(! isSalesExist.data) {
                    alert('該当する販売データがありません')
                    return;
                };
                // 引落年月をセッション保存
                this.setSession(this.sessionName, { createForm : this.createForm });
            } catch (error) {
                return;
            }

            location.href = (`${this.documentRoot}/draw/create?DRAW_YM=${this.createForm.DRAW_YM}`)
        },
        edit(drawNo) {
            location.href = (`${this.documentRoot}/draw/${drawNo}/edit`)
        },
        reset() {
            this.init();
            this.getDraws();
        },
        setStatusLabel(code) {
            return `${this.invoiceStatusList[code]}`;
        }
    },
    computed: {
        statusListArray() {
            return Object.keys(this.invoiceStatusList);
        },
    }
}
</script>